<template>
  <div>
    <b-alert show variant="light" class="border">
      <template v-if="kind === 'compras'">
        Formato en blanco con los <b>insumos activos</b> del catálogo, agrupados por categoría y con el
        último precio de compra como referencia. Imprímelo, anota cantidades y precios, y después captura la compra en el sistema.
      </template>
      <template v-else>
        Formato de <b>conteo ciego</b> con los insumos activos del catálogo, agrupados por categoría
        (no muestra la existencia del sistema). Anota lo contado y después captúralo en un ajuste de inventario.
      </template>
    </b-alert>

    <b-form-group label="Categorías (vacío = todas):">
      <b-form-checkbox-group v-model="categoryIds" :options="categoryOptions" stacked style="max-height: 200px; overflow-y: auto;"></b-form-checkbox-group>
    </b-form-group>

    <b-form-group v-if="kind === 'compras'" label="Proveedor (opcional, se imprime en el encabezado):">
      <b-form-select v-model="providerId" :options="providerOptions"></b-form-select>
    </b-form-group>
    <b-form-group v-else label="Almacén / ubicación (opcional, se imprime en el encabezado):">
      <b-form-select v-model="locationId" :options="locationOptions"></b-form-select>
    </b-form-group>

    <div class="text-right">
      <b-button variant="danger" class="mr-2" :disabled="!!downloading" @click="download('pdf')">
        <b-spinner v-if="downloading === 'pdf'" small></b-spinner>
        <i v-else class="fas fa-file-pdf mr-1"></i> Descargar PDF
      </b-button>
      <b-button variant="success" :disabled="!!downloading" @click="download('xlsx')">
        <b-spinner v-if="downloading === 'xlsx'" small></b-spinner>
        <i v-else class="fas fa-file-excel mr-1"></i> Descargar Excel
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SupplyFormatDownload",
  props: {
    // "compras" | "inventario"
    kind: { type: String, required: true },
  },
  data() {
    return {
      categories: [],
      providers: [],
      locations: [],
      categoryIds: [],
      providerId: null,
      locationId: null,
      downloading: null,
    };
  },
  computed: {
    categoryOptions() {
      return this.categories
        .filter((c) => c.status)
        .map((c) => ({ value: c.id, text: c.name }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    providerOptions() {
      return [{ value: null, text: "— Sin proveedor —" }].concat(
        this.providers.filter((p) => p.status).map((p) => ({ value: p.id, text: p.name }))
      );
    },
    locationOptions() {
      return [{ value: null, text: "— Sin ubicación —" }].concat(
        this.locations.map((l) => ({ value: l.id, text: l.complete_name || l.name }))
      );
    },
  },
  mounted() {
    axios.get("/supplycategories").then((r) => (this.categories = r.data || [])).catch(() => {});
    if (this.kind === "compras") {
      axios.get("/providers").then((r) => (this.providers = r.data || [])).catch(() => {});
    } else {
      axios
        .get("/stocklocations")
        .then((r) => (this.locations = (r.data || []).filter((n) => n.type_usage == "internal")))
        .catch(() => {});
    }
  },
  methods: {
    download(format) {
      const params = { format };
      if (this.categoryIds.length) params.category_ids = this.categoryIds.join(",");
      if (this.kind === "compras" && this.providerId) params.provider_id = this.providerId;
      if (this.kind === "inventario" && this.locationId) params.location_id = this.locationId;

      this.downloading = format;
      axios
        .get("/supplies/formats/" + this.kind, { params, responseType: "blob", headers: { Accept: "*/*" } })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let filename = "formato_" + this.kind + "." + format;
          const cd = response.headers["content-disposition"];
          if (cd && cd.includes("filename")) {
            const m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(cd);
            if (m != null && m[1]) filename = m[1].replace(/['"]/g, "");
          }
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(async (err) => {
          // Error bodies come back as Blob because of responseType.
          let msg = "No se pudo descargar el formato";
          const data = err.response && err.response.data;
          if (data instanceof Blob) {
            try {
              const parsed = JSON.parse(await data.text());
              msg += ": " + (parsed.error || parsed.message || parsed);
            } catch (e) {
              /* keep generic message */
            }
          }
          this.$bvToast.toast(msg, { title: "Error", variant: "danger", solid: true });
        })
        .finally(() => {
          this.downloading = null;
        });
    },
  },
};
</script>
